import React from 'react';
import { Controller } from 'react-hook-form';
import { CMPText } from '../../ui/styled';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';

const CMPFormInputText = (props) => {
  const {
    name,
    control,
    label,
    type,
    shrink,
    multiline,
    rows,
    disabled,
    register,
    minValue,
    maxValue,
    readOnly,
    errors,
    helperText,
    placeholder,
  } = props;
  return (
    <Box sx={{ display: 'flex' }}>
      <Controller
        name={name}
        control={control}
        register={register}
        render={({
          field: { onChange, onBlur, value },
          fieldState: { error },
          formState,
        }) => (
          <CMPText
            sx={{height: '24px', width: '180px;'}}
            onChange={onChange}
            value={value == null ? '' : value}
            defaultValue={value == null ? '' : value}
            disabled={disabled}
            fullWidth
            //label={label}
            type={type}
            variant='outlined'
            multiline={multiline}
            error={errors}
            helperText={helperText}
            placeholder={placeholder}
            rows={rows}
            onBlur={onBlur}
            InputLabelProps={{
              shrink: shrink,
            }}
            InputProps={{
              inputProps: { min: minValue, max: maxValue, readOnly: readOnly },
            }}
          />
        )}
      /><InputLabel sx={{paddingLeft: '6px;'}}>{label}</InputLabel>
    </Box>  
  );
};

export default CMPFormInputText;
